
import { VSnackbar } from "vuetify/lib";

export default VSnackbar.extend({});
